document.addEventListener('DOMContentLoaded', ()=> {
    let height = document.querySelector(".c-page-text-fv").offsetHeight + document.querySelector(".header-wrapper").offsetHeight;
    let isDisplay = false;
    
    document.addEventListener('scroll', function() {
        if (scrollY > height && !isDisplay) {
            document.querySelector('.event__popup').classList.add('display');
            document.querySelector('.event__popup_bg').classList.add('display');
            isDisplay = true;
        }
    }, {passive: true});
    
    window.addEventListener('resize', function() {
        height = document.querySelector(".c-page-text-fv").offsetHeight + document.querySelector(".header-wrapper").offsetHeight;
    });
    
    document.querySelector('.event__popup_bg').addEventListener('click', () => {
        document.querySelector('.event__popup').classList.remove('display');
        document.querySelector('.event__popup_bg').classList.remove('display');
    });
    
    document.querySelector('.event__batsu').addEventListener('click', () => {
        document.querySelector('.event__popup').classList.remove('display');
        document.querySelector('.event__popup_bg').classList.remove('display');
    });
    
    document.querySelector('.event__popup_link').addEventListener('click', () => {
        document.querySelector('.event__popup').classList.remove('display');
        document.querySelector('.event__popup_bg').classList.remove('display');
    });
});